import React, { useCallback, useEffect, useMemo, useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import {
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Modal,
  //   Radio,
  Row,
  Select,
  Spin,
  Tag,
  Typography,
  message,
  notification,
} from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form/Form';
import {
  FinContractResponse,
  getFinContractById,
  getFinModificationByModid,
  getFinModificationValidByCtrid,
  getPopulationToInvoiceByCriteria,
  getTPOFFees,
} from 'services/fincontract';
import { useQuery } from 'react-query';
import UtinaCard from 'components/UtinaCard';
import Value from 'components/Value';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  dateToString,
  indexBy,
  setValueByNamePath,
  toDatePickerDate,
} from 'utils/utils2';
import ParListSelect from 'components/ParListSelect';
import TextArea from 'antd/lib/input/TextArea';
import { toCurrency } from 'utils/utils';
import InputCurrency from 'components/InputCurrency';
import _, { debounce, isNil } from 'lodash';
import { calculatePrefinInterestByContract } from 'services/clientInvoice';
import moment from 'moment';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import SliderWithInput from 'components/SliderWithInput';
import InputRate from 'components/InputRate';
import { getWACCPayNettingView } from 'services/PaymentServices';
import { PricingResponse } from 'services/pricing';
import * as finEngine from 'services/finEngine';
import FormItem from 'antd/lib/form/FormItem';
// import ElementsTable from 'pages/ProposalV3/PropDetail/ElementsTable';
const { Text } = Typography;

export type TabColCommentProps = {
  form: FormInstance;
  objectid: number;
  object: string;
};

const TabLoanReimbursment = ({
  objectid,
  object,
  form,
}: TabColCommentProps) => {
  const [mode, setMode] = useState('SIMUL');
  const [targetStatus, setTargetStatus] = useState('PARTIAL');
  const [isLoading, setisLoading] = useState('');
  const [state, setState] = useState({
    isLoading: false,
    remainDuration: '',
    outstandingamount: 0,
    newOutStanding: 0,
    oldRental: 0,
    newRental: 0,
    effectDate: '',
  });

  let [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);

  const { data: modList } = useQuery(
    ['getFinModificationValidByCtrid', { ctrid: objectid }],
    () =>
      getFinModificationValidByCtrid({
        ctrid: objectid,
        modevent: 'PREFINREIM',
      }).then((res) => res.list),
    { refetchOnMount: true }
  );

  const { data: contract, isFetching } = useQuery(
    ['getFinContractById', objectid],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data),
    {
      refetchOnWindowFocus: false,
    }
  );

  const { data: payList, isFetching: payFetching } = useQuery(
    ['getWACCPayNettingView', contract?.tpidclient, contract?.currcode],
    () =>
      getWACCPayNettingView({
        tpid: contract?.tpidclient ?? 0,
        currcode: contract?.currcode ?? '',
      }).then((response) => {
        if (response.code !== '200') {
          notification.info({ message: response.message });
          // state.listInvoice = [];
          // state.listOfInvoices = [];
          return;
        }
        const listInvoice = response.list
          .filter(
            (obj) =>
              obj.paynetstatus !== 'USED' &&
              obj.paynetstatus !== 'CANCEL' &&
              obj?.payremainingamount > 0
          )
          .map((object: any) => ({
            text: ` ${object.payreference} - Rem.Amnt : ${toCurrency(
              object.payremainingamount,
              object.currcode ?? localStorage.getItem('currcode') ?? ''
            )} `,
            value: object.payid,
            type: 'REIM',
            payAmount: object.credit,
            payreference: object.payreference,
            paydocdate: object.paydocdate,
          }));
        return listInvoice;
      }),
    { enabled: contract !== undefined && mode === 'REAL' }
  );

  //   const updateState = useCallback(
  //     (values) => {
  //       setState((prev) => ({ ...prev, ...values }));
  //     },
  //     [setState]
  //   );
  const notInvoicedSchedule = contract?.conElements
    ?.find((e) => e.ctetype === 'FIN')
    ?.conElemSchedules.filter(
      (s) =>
        s.ciid === null &&
        s.ctstype !== 'UPFRONT' &&
        s.ctstype !== 'RV' &&
        s.ctstype !== 'DEFINT'
    );

  const optionDates = notInvoicedSchedule?.map(
    (e, index) =>
      e.ctstype !== 'UPFRONT' && (
        <option
          key={index}
          value={e.ctsduedate.toString()}
          selected={index === 0 ? true : false}
        >
          {e.ctsduedate}
        </option>
      )
  );
  const handleFinModSelect = (finmod: number) => {
    if (finmod === undefined) {
      //   updateState({ isModSelected: false });
      return;
    }

    setMode('REAL');
    form.setFieldValue('mode', 'REAL');

    // updateState({ isLoading: true });

    let query = getFinModificationByModid({ modid: finmod });

    setisLoading('POFF');

    query
      .then((response) => {
        if (response.code !== '200') {
          return;
        }
        const res = response.data;

        let elemList = res.simulParams
          .find((item) => item.parcode === 'ELEMENTS' && item.partype === 'IN')
          ?.finModSimulParamElements.map((e) => {
            return {
              ...e,
              payOffAmount: e?.outstandingamount - e?.newoutstandingamount,
            };
          });
        let effectDate = res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue;

        console.log('effectDate::',effectDate)

        let targetStatus = res.simulParams.find(
          (item) => item.parcode === 'TARGETSTAT' && item.partype === 'IN'
        )?.newvalue;
        if (targetStatus !== undefined) {
          setTargetStatus(targetStatus);
        }

        let intereststoinvoice = Number(
          res.simulParams.find(
            (item) => item.parcode === 'INTERESTMT' && item.partype === 'IN'
          )?.newvalue
        );

        let payoffamount = Number(
          res.simulParams.find(
            (item) => item.parcode === 'INPPOFFAMT' && item.partype === 'IN'
          )?.newvalue
        );

        form?.setFieldsValue({
          mode: 'REAL',
          effectDate: toDatePickerDate(effectDate),

          ctenddate: Number(
            res.simulParams.find(
              (item) => item.parcode === 'ENDDATE' && item.partype === 'IN'
            )?.newvalue
          ),

          newDuration: res.simulParams.find(
            (item) => item.parcode === 'DURATION' && item.partype === 'IN'
          )?.newvalue,

          newRate: res.simulParams.find(
            (item) => item.parcode === 'NEWRATE' && item.partype === 'IN'
          )?.newvalue,

          gpMethod: res.simulParams.find(
            (item) => item.parcode === 'PAYID' && item.partype === 'IN'
          )?.newvalue,

          inPartialPayoffAmount: res.simulParams.find(
            (item) => item.parcode === 'INPPOFFAMT' && item.partype === 'IN'
          )?.newvalue,

          payOffFormula: Number(
            res.simulParams.find(
              (item) => item.parcode === 'INPPOFFORM' && item.partype === 'IN'
            )?.newvalue
          ),

          intereststoinvoice: intereststoinvoice,
          totaltoinvoice: intereststoinvoice + payoffamount,

          payOffFeesAmount: Number(
            res.simulParams.find(
              (item) => item.parcode === 'INPPOFFEES' && item.partype === 'IN'
            )?.newvalue
          ),

          comment: response.data.modcomment,

          feesFormula: Number(
            res.simulParams.find(
              (item) => item.parcode === 'FEESFORM' && item.partype === 'IN'
            )?.newvalue
          ),
          feesAmount: res.simulParams.find(
            (item) => item.parcode === 'FEESAMNT' && item.partype === 'IN'
          )?.newvalue,
            // (item) => item.parcode === 'MODREASON' && item.partype === 'IN'

          modreason: res.simulParams.find(
            (item) => item.parcode === 'LPREIMREAS' && item.partype === 'IN'
          )?.newvalue,
          targetStatus: targetStatus,

          elemList: elemList,
          payOffAmount: _.sumBy(elemList, 'payOffAmount'),
          newOutstanding: _.sumBy(elemList, 'newoutstandingamount'),
        });

        setisLoading('');

        // calculatefeesToInvoice(effectDate);
        let selectElem: any = elemList
          ?.filter((el) => el.flagpayoff)
          .map((e) => e.cteid);

        setSelectedRowKeys(selectElem);
        /* handleEffectDateChange(
        res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue
      );*/

        const targetDate = form?.getFieldValue('effectDate');

        const defintMethod = form?.getFieldValue('defintMethod');
        const newDueDate = form?.getFieldValue('newDueDate');
        const defintNominalRate = form?.getFieldValue('defintNominalRate');

        const gpDuration = form?.getFieldValue('gpDuration');
        const gpMethod = form?.getFieldValue('gpMethod');
        const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
        const gpNominalRate = form?.getFieldValue('gpNominalRate');
        const extendDuration =
          gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');

        const inPartialPayoffAmount = form?.getFieldValue(
          'inPartialPayoffAmount'
        );
        const inPartialPayoffFormula = form?.getFieldValue(
          'inPartialPayoffFormula'
        );
        const inPartialPayoffFeesAmount = form?.getFieldValue(
          'inPartialPayoffFeesAmount'
        );

        const newRate = form?.getFieldValue('newRate');

        const newRv = form?.getFieldValue('newRv');

        const newDuration = form?.getFieldValue('newDuration');

        /*calculate(
        objectid,
        newRv ?? rvDefault,
        gpDuration,
        gpMethod,
        gpPeriodicity,
        gpNominalRate,
        extendDuration,
        newDuration,
        newRate,
        0,
        '',
        targetDate,
        newDueDate,
        defintMethod,
        defintNominalRate,
        inPartialPayoffAmount,
        inPartialPayoffFormula,
        inPartialPayoffFeesAmount
      );*/

        //   updateState({ isLoading: false });
      })
      .catch(() => {
        setisLoading('');
      });
  };

  const calculateTPOFFees = (pricing: PricingResponse) => {
    if (
      ['OUTRENTAL', 'OUTINT', 'TOTXINT'].indexOf(
        pricing?.serviceResponse?.servbasis
      ) > -1
    ) {
      let newDuration = form?.getFieldValue('newDuration');

      const effectDate = form?.getFieldValue('effectDate');
      getTPOFFees({
        ctrid: contract?.ctrid ?? 0,
        calculationbasis: pricing?.serviceResponse?.servbasis ?? '',
        duedate: dateToString(effectDate),
        nbMonths: newDuration,
      }).then((res) => {
        form?.setFieldsValue({
          payOffFeesAmount: res.data,
          payOffFormula: pricing?.priid,
          payOffFormulalabel: pricing?.prilabel
        });
      });
    } else {
      calculateFees(pricing, true);
    }
  };

  const calculatefeesToInvoice = (calculationDate?: any) => {
    let date =
      dateToString(calculationDate) ??
      dateToString(form.getFieldValue('effectDate')) ??
      dateToString(moment(new Date(), 'YYYY-MM-DD'));
    setisLoading('INTERSET');

    if (!isNil(date) && date !== '') {
      getPopulationToInvoiceByCriteria({
        duedate: date,
        ctrid: objectid,
        mgid: Number(localStorage.getItem('mgid')),
        citype: 'RENTAL',
        groupingmode: 'RENTAL',
        flagCalcAtDate: true,
        isSimulation: true,
      })
        .then((response) => {
          setisLoading('');
          let totalInterest = _.sumBy(response.list, 'ctsinterestamount');
          let payOffAmount = form.getFieldValue('payOffAmount');

          form.setFieldsValue({
            intereststoinvoice: totalInterest,
            totaltoinvoice: totalInterest + payOffAmount,
          });
        })
        .catch(() => {
          setisLoading('');
        });
    }
  };

  const calculatePreFin = (calculationDate?: any) => {
    let date =
      dateToString(calculationDate) ??
      dateToString(form.getFieldValue('effectDate')) ??
      dateToString(moment(new Date(), 'YYYY-MM-DD'));
    setisLoading('INTERSET');

    if (!isNil(date) && date !== '') {
      calculatePrefinInterestByContract({
        ctrid: objectid,
        mode: 'CALCUL',
        calculationDate: date,
        jobid: 0,
      })
        .then((response) => {
          setisLoading('');
          let totalInterest = _.sumBy(response.list, 'calculatedamount');
          let payOffAmount = form.getFieldValue('payOffAmount');

          form.setFieldsValue({
            intereststoinvoice: totalInterest,
            totaltoinvoice: totalInterest + payOffAmount,
          });
        })
        .catch(() => {
          setisLoading('');
        });
    }
  };

  const calculateFees = (
    pricing?: PricingResponse,
    updatePPOFFees?: boolean
  ) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: contract?.conElements[0]?.conElemSchedules ?? [],
          inDownPayment: 0,
          inFinAmount: contract?.conElements[0]?.ctefinancedamount ?? 0,
          inFollowGP: true,
          inGPDuration: contract?.conElements[0].ctegraceperiodduration ?? 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse?.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse?.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse?.servduration ?? '',
          inServpercentage: pricing?.serviceResponse?.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: 20,
          inDuration: contract?.conElements[0].cteduration ?? 0,
          inInvestAmount: contract?.conElements[0].cteinvestamount ?? 0,
          inAssetAmount: contract?.assets[0]?.assetnetamount ?? 0,
          inServperiodicity: pricing?.serviceResponse?.servperiodicity ?? '1',
          inServDurationFree:
            pricing?.serviceResponse?.servdurationdefault ?? 1,
          inStartDate: dateToString(form?.getFieldValue('effectDate')),
          inServbasis: pricing?.serviceResponse?.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse?.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse?.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse?.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          if (updatePPOFFees) {
            form?.setFieldsValue({
              payOffFeesAmount: res.installmentamount,
              payOffFormula: pricing?.priid,
              payOffFormulalabel: pricing?.prilabel
            });
          } else {
            form?.setFieldsValue({
              feesAmount: res.installmentamount,
              feesFormula: pricing?.priid,
            });
          }
        }
      });
  };

  const reset = () => {
    if (contract) {
      let ct: FinContractResponse = contract;

      const elemFin = contract?.conElements?.find(
        (e) => e.ctetype === 'FIN' && e.ctestatus !== 'TERM'
      );

      let outstandingamount = _.sumBy(
        contract?.conElements?.filter(
          (e) => e.ctetype === 'FIN' && e.ctestatus !== 'TERM'
        ),
        'cteinvestamount'
      );

      let schedule = contract?.conElements
        ?.filter((e) => e.ctetype === 'FIN' && e.ctestatus !== 'TERM')[0]
        ?.conElemSchedules?.filter((c) => c.ciid !== null);

      // let lastinvoicedate = _.maxBy(schedule, 'ctsduedate')?.ctsduedate;
      let lastinvoicedate = '';
      if (schedule) {
        if (form?.getFieldValue('effectDate')) {
          lastinvoicedate = moment(form.getFieldValue('effectDate')).format(
            'YYYY-MM-DD'
          );
        } else {
          lastinvoicedate = moment(schedule[0]?.ctsduedate).format(
            'YYYY-MM-DD'
          );
        }
      }

      let remainDuration =
        notInvoicedSchedule?.filter(
          (e) => moment(e.ctsduedate).format('YYYY-MM-DD') >= lastinvoicedate
        ).length ?? 0;


      let lastinvoicamount = _.maxBy(schedule, 'ctsduedate')?.ctstotalamount;

      let totalInv = 0;
      let totalReim = 0;
      if (contract?.ctfclevel === 'PROPOSAL') {
        totalReim = contract?.ctfinancedamount - outstandingamount;

        contract?.conElements.forEach((e) => {
          totalInv =
            totalInv +
            _.sumBy(
              e.conElemSchedules?.filter((c) => c.ciid !== null),
              'ctsrentalamount'
            );
        });
      }

      form?.setFieldsValue({
        event: 'tabLoanReimbursment',
        flagretailer: ct?.flagretailer,
        ctactivationdate: ct?.ctactivationdate,
        mfusedamount: ct?.mfusedamount,
        ctenddate: ct?.ctenddate,
        ctfinancedamount: ct?.ctfinancedamount,
        lastinvoicedate: lastinvoicedate,
        lastinvoicamount: lastinvoicamount,
        totalreimbursment: totalReim,
        totalinvoicedamount: totalInv,
        outstandingamount: outstandingamount,
        newOutstanding: 0,
        intereststoinvoice: 0,
        currcode: contract.currcode,
        payOffAmount: 0,
        newDuration: form.getFieldValue('flagretailer')
          ? remainDuration
          : elemFin?.cteduration,
        oldDuration: elemFin?.cteduration,
        newRate: elemFin?.ctenominalrate,
        effectDate: form.getFieldValue('flagretailer')
          ? form.getFieldValue('effectDate')
          : !isNil(lastinvoicedate) && lastinvoicedate !== ''
          ? toDatePickerDate(lastinvoicedate)
          : moment(new Date(), 'YYYY-MM-DD'),
        mode: 'SIMUL',
        comment: '',
        payid: '' as any,
        paymount: 0,
      });

      calculatePreFin(lastinvoicedate);

      let elemList: any[] = [];
      if (contract?.flagretailer) {
        elemList = contract?.conElements?.filter(
          (elem: any) => elem.ctetype === 'FIN'
        );
      } else {
        elemList = contract?.conElements?.filter(
          (elem: any) =>
            elem.ctecalculationtype === 'PREFIN' && elem.ctestatus !== 'TERM'
        );
      }

      const newElemList = elemList.map((e) => {
        return {
          ...e,
          outstandingamount:
            e?.conElemSchedules[0]?.ctsoutstandingamount ?? e?.cteinvestamount,
          newoutstandingamount:
            e?.conElemSchedules[0]?.ctsoutstandingamount ?? e?.cteinvestamount,
        };
      });

      let newnewOutstanding = 0;
      // newnewOutstanding =   - _.sumBy(newElemList, 'payOffAmount');
      form.setFieldValue(
        'newOutstanding',
        _.sumBy(newElemList, 'newoutstandingamount')
      );
      setSelectedRowKeys([]);

      form.setFieldValue('elemList', newElemList);
    }
  };

  useEffect(() => {
    reset();
  }, [contract, form]);

  const getName = useCallback(
    (name: string) => (record: any) => {
      const elemList = form.getFieldValue('elemList');
      const index = indexBy(elemList, 'cteid')[record.cteid];
      return ['elemList', index, name];
    },
    [form]
  );

  const onChangeReimbursment = debounce((record: any, payOffAmount: any) => {
    setValueByNamePath(
      form,
      getName('newoutstandingamount')(record),
      record.outstandingamount - Number(payOffAmount)
    );

    let newoutstandingamount = 0;

    newoutstandingamount = _.sumBy(
      form.getFieldValue('elemList'),
      'newoutstandingamount'
    );
    console.log('elemList::',form.getFieldValue('elemList'))

    payOffAmount = _.sumBy(form.getFieldValue('elemList'), 'payOffAmount');

    form.setFieldsValue({
      newOutstanding: newoutstandingamount,
      payOffAmount: payOffAmount,
    });

    setisLoading('');
  }, 1000);

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      //   {
      //     dataIndex: 'flagpayoff',
      //     width: '90px',
      //     render: (val, record) => String(val ?? false),
      //   },
      // {
      //   dataIndex: 'ctecategorylabel',
      //   width: '150px',
      // },

      {
        dataIndex: 'ctedescription',
        width: '200px',
      },
      {
        dataIndex: 'cteinvestamount',
        width: '150px',
        align: 'right',
        render: (val, record) => toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'outstandingamount',
        width: '150px',
        align: 'right',
        render: (val, record) =>
          form.getFieldValue('flagretailer')
            ? toCurrency(state.outstandingamount)
            : toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'payOffAmount',
        width: '150px',
        align: 'right',
        render: (value, record) => (
          <Form.Item name={getName('payOffAmount')(record)} noStyle>
            {(form.getFieldValue('flagretailer') && mode === 'SIMUL')? (
              <InputCurrency
                currcode={record.currcode}
                disabled={!record.flagpayoff}
                onChange={(e: any) => {
                  setisLoading('POFF');
                  onChangeReimbursment(record, e);
                }}
                max={state.outstandingamount}
              />
            ) : (
              <InputCurrency
                currcode={record.currcode}
                disabled={!record.flagpayoff || mode === 'REAL'}
                onChange={(e: any) => {
                  setisLoading('POFF');
                  onChangeReimbursment(record, e);
                }}
                max={record.ctefinancedamount}
              />
            )}
          </Form.Item>
        ),
      },

      {
        dataIndex: 'newoutstandingamount',
        width: '150px',
        align: 'right',
        render: (val, record) => toCurrency(val, record.currcode),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, mode, state]
  );

  const onChangeSelectedRow = (selectedRowKeys: any[], selectedRows: any[]) => {
    setSelectedRowKeys(selectedRowKeys);

    let rows = form.getFieldValue('elemList')?.map((el: any) => {
      let elem = selectedRows.find((row: any) => row.cteid === el.cteid);
      if (elem) {
        let payOffAmount = form.getFieldValue('flagretailer') && mode ==='REAL'
          ? state.outstandingamount
          : Number(elem.payOffAmount) > 0
          ? Number(elem.payOffAmount)
          : Number(elem.outstandingamount);

        let newoutstandingamount =
          Number(elem?.outstandingamount) - Number(payOffAmount);

        return {
          ...elem,
          newoutstandingamount: newoutstandingamount,
          payOffAmount: payOffAmount,
          flagpayoff: true,
          // totaltoinvoice: payOffAmount,
        };
      } else {
        return {
          ...el,
          payOffAmount: 0,
          newoutstandingamount: el.outstandingamount,
          flagpayoff: false,
        };
      }
    });
    form.setFieldValue('elemList', rows);
    let newnewOutstanding = 0;

    // newnewOutstanding =
    //   form.getFieldValue('outStanding') - _.sumBy(rows, 'payOffAmount');
    // form.setFieldValue('newOutstanding', newnewOutstanding);

    form.setFieldValue('payOffAmount', _.sumBy(rows, 'payOffAmount'));
    if (form.getFieldValue('flagretailer')) {
      form.setFieldValue('newOutstanding', newnewOutstanding);
    } else {
      form.setFieldValue(
        'newOutstanding',
        _.sumBy(rows, 'newoutstandingamount')
      );
    }
  };

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    onChange: onChangeSelectedRow,
    selectedRowKeys: selectedRowKeys,
  };

  const onChangepayOffAmount = debounce((e: any) => {
    let payOffAmount = Number(e);
    let newlist: any[] = [];
    let _selectedRowKeys: any[] = [];
    form.getFieldValue('elemList')?.forEach((el: any) => {
      if (payOffAmount > el.outstandingamount) {
        _selectedRowKeys.push(el.cteid);
        setValueByNamePath(
          form,
          getName('payOffAmount')(el),
          el.outstandingamount
        );

        setValueByNamePath(form, getName('flagpayoff')(el), true);
        setValueByNamePath(form, getName('newoutstandingamount')(el), 0);
        payOffAmount -= el.payOffAmount;
      } else if (payOffAmount <= el.outstandingamount && payOffAmount > 0) {
        _selectedRowKeys.push(el.cteid);
        let newoutstanding = el.outstandingamount - payOffAmount;
        setValueByNamePath(form, getName('payOffAmount')(el), payOffAmount);
        setValueByNamePath(
          form,
          getName('newoutstandingamount')(el),
          newoutstanding
        );

        setValueByNamePath(form, getName('flagpayoff')(el), true);
        payOffAmount = 0;
      } else if (payOffAmount <= el.outstandingamount && payOffAmount === 0) {
        setValueByNamePath(form, getName('payOffAmount')(el), 0);
        setValueByNamePath(
          form,
          getName('newoutstandingamount')(el),
          el.outstandingamount
        );

        setValueByNamePath(form, getName('flagpayoff')(el), false);
        payOffAmount = 0;
      } else {
        payOffAmount = 0;
        setValueByNamePath(form, getName('payOffAmount')(el), 0);

        setValueByNamePath(form, getName('flagpayoff')(el), false);
        setValueByNamePath(form, getName('newoutstandingamount')(el), 0);
      }
    });
    let elemList = form.getFieldValue('elemList');

    setSelectedRowKeys(_selectedRowKeys);
    let newOutstanding = _.sumBy(elemList, 'newoutstandingamount');

    form.setFieldValue('newOutstanding', newOutstanding);

    setisLoading('');
  }, 1000);

  const onPaymentSelect = (e: any) => {
    let payment = payList?.find((p) => p.value === e);

    if (payment !== undefined) {
      const error = () => {
        Modal.error({
          content: (
            <Card style={{ padding: 3, background: '#fff' }}>
              <h3>
                {`The payment amount ${toCurrency(
                  payment?.payAmount
                )} is less than the agreed payoff ${toCurrency(
                  form.getFieldValue('payOffAmount')
                )}.`}
              </h3>
            </Card>
          ),
          onOk: () => {
            form.setFieldsValue({
              payid: '' as any,
            });
          },
          onCancel: () => {
            form.setFieldsValue({
              payid: '' as any,
            });
          },
          width: 550,
        });
      };
      if (payment.payAmount < form.getFieldValue('payOffAmount')) {
        error();
      } else {
        form.setFieldsValue({
          paymount: payment?.payAmount,
          payreference: payment?.payreference,
        });
      }
    }
  };

  const disableDaysBeforeToday = useCallback(
    (d) => {
      if (d == null) {
        return null;
      }

      let lastinvoicedate = form?.getFieldValue('lastinvoicedate');

      return (
        moment(lastinvoicedate) != null &&
        d.isBefore(moment(lastinvoicedate)) &&
        !d.isSame(moment(lastinvoicedate), 'day')
      );
    },
    [form?.getFieldValue('lastinvoicedate')]
  );

  const handleEffectDateChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }

    const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');

    const gpDuration = form?.getFieldValue('gpDuration') ?? 0;
    const gpMethod = form?.getFieldValue('gpMethod');
    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');
    const extendDuration =
      gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');

    const inPartialPayoffAmount = form?.getFieldValue('inPartialPayoffAmount');
    const inPartialPayoffFormula = form?.getFieldValue(
      'inPartialPayoffFormula'
    );
    const inPartialPayoffFeesAmount = form?.getFieldValue(
      'inPartialPayoffFeesAmount'
    );

    const newRate = form?.getFieldValue('newRate');

    // const remainDuration = notInvoicedSchedule?.filter(
    //   (e) => e.ctsduedate >= value
    // ).length;

    const remainDuration = notInvoicedSchedule
      ? notInvoicedSchedule.filter((e) => e.ctsduedate >= value).length
      : 0;

    const fremainDuration = remainDuration ? remainDuration : 0;
    console.log('remainDuration::', remainDuration);

    const outstanding = notInvoicedSchedule?.find(
      (e) => e.ctsduedate === value
    )?.ctsstartamount;

    // const fvvalue: Array<AssetFutureValueScheduleResponse> =
    //   fvList?.filter((e) => e?.prcode === 'LEASING')[0]?.fvSchedule ?? [];

    // const fvamount = fvvalue?.find((e) => e.fvdate === value)?.fvamount;

    // const fvamountend = fvvalue[fvvalue.length - 1]?.fvamount;

    const oldRental = notInvoicedSchedule?.find(
      (e) => e.ctsduedate === value
    )?.ctsrentalamount;

    // state.fvamount = fvamount ?? 0;
    // state.fvamountend = fvamountend ?? 0;
    state.remainDuration = String(fremainDuration);
    state.outstandingamount = outstanding ?? 0;
    // state.newOutStanding = outstanding ?? 0;

    state.oldRental = oldRental ?? 0;
    form.setFieldsValue({
      outstandingamount: outstanding,
      payOffAmount: outstanding,
      newOutStanding: 0,
      totaltoinvoice: outstanding,
    });

    const newState = state;
    setState(state);

    // calculatefeesToInvoice(value);
    setisLoading('');
    // form?.setFieldsValue({ newRv: rvDefault ?? 0 });
  };

  return (
    <DF.Provider
      pagcode="tabLoanReimbursment"
      entity={object}
      entityid={objectid}
    >
      <Form form={form} layout="vertical">
        <FormItem shouldUpdate noStyle>
          <Spin spinning={isFetching}>
            <UtinaCard comcode="tabLoanReimbursment" level={5}>
              <Row gutter={10}>
                <FormInput
                  col
                  md={5}
                  name="mode"
                  rules={[{ required: true }]}
                  initialValue={mode}
                >
                  <div className="radio-group">
                    <span
                      className={
                        mode === 'SIMUL'
                          ? 'radio-button radio-button-checked'
                          : 'radio-button'
                      }
                      onClick={() => {
                        setMode('SIMUL');
                        form.setFieldsValue({
                          modid: undefined,
                          mode: 'SIMUL',
                        });
                        reset();
                      }}
                    >
                      SIMUL
                    </span>
                    <span
                      className={
                        mode === 'REAL'
                          ? 'radio-button radio-button-checked'
                          : 'radio-button'
                      }
                      onClick={() => {
                        reset();
                        setMode('REAL');
                        form.setFieldValue('mode', 'REAL');
                      }}
                    >
                      REAL
                    </span>
                  </div>
                </FormInput>

                <FormInput
                  col
                  md={5}
                  name="targetStatus"
                  rules={[{ required: true }]}
                  initialValue={mode}
                  shouldUpdate
                >
                  <div className="radio-group">
                    <span
                      className={
                        targetStatus === 'PARTIAL'
                          ? 'radio-button radio-button-checked'
                          : 'radio-button'
                      }
                      onClick={() => {
                        if (mode !== 'REAL') {
                          setTargetStatus('PARTIAL');
                          form.setFieldsValue({ targetStatus: 'PARTIAL' });
                          reset();
                        }
                      }}
                    >
                      PARTIAL
                    </span>
                    <span
                      className={
                        targetStatus === 'TOTAL'
                          ? 'radio-button radio-button-checked'
                          : 'radio-button'
                      }
                      onClick={() => {
                        if (mode !== 'REAL') {
                          reset();
                          setTargetStatus('TOTAL');
                          form.setFieldValue('targetStatus', 'TOTAL');
                          setisLoading('');
                          const rowkeysElem = form
                            .getFieldValue('elemList')
                            ?.map((elem: any) => {
                              return elem.cteid;
                            });
                          onChangeSelectedRow(
                            rowkeysElem ?? [],
                            form.getFieldValue('elemList') ?? []
                          );
                        }
                      }}
                    >
                      Total
                    </span>
                  </div>
                </FormInput>

                {mode === 'REAL' && (
                  <>
                    <FormInput
                      col
                      md={8}
                      name="modid"
                      labelAlign="left"
                      rules={[{ required: mode === 'REAL' }]}
                    >
                      <Select
                        allowClear
                        style={{ width: '100%' }}
                        onSelect={handleFinModSelect}
                        onClear={() => {
                          reset();
                        }}
                      >
                        {modList?.map((e: any, index: number) => (
                          <Select.Option key={index} value={e.modid}>
                            {e.ctreference +
                              ' - ' +
                              e.modid +
                              ' - ' +
                              e.modcomment}
                          </Select.Option>
                        ))}
                      </Select>
                    </FormInput>

                    <FormInput
                      col
                      md={6}
                      name="payid"
                      labelAlign="left"
                      rules={[{ required: mode === 'REAL' }]}
                      shouldUpdate
                    >
                      <Select
                        allowClear
                        style={{ width: '100%' }}
                        onSelect={(e) => {
                          onPaymentSelect(e);
                        }}
                        loading={payFetching}
                        disabled={
                          form.getFieldValue('modid') === 0 ||
                          form.getFieldValue('modid') === undefined
                        }
                      >
                        {payList?.map((e, index) => (
                          <Select.Option key={index} value={e.value}>
                            {e.text}
                          </Select.Option>
                        ))}
                      </Select>
                    </FormInput>

                    <FormInput
                      col
                      md={5}
                      name="paymount"
                      labelAlign="left"
                      rules={[{ required: mode === 'REAL' }]}
                    >
                      <Value formatter={(val) => toCurrency(val)} />
                    </FormInput>
                  </>
                )}
              </Row>
              <Divider />
              <Row gutter={10}>
                <FormInput col md={6} name="ctactivationdate">
                  <Value />
                </FormInput>
                <FormInput col md={6} name="ctenddate">
                  <Value />
                </FormInput>

                <Col md={6}>
                  <FormInput name="ctfinancedamount" comcode="approuvedAmount">
                    <Value formatter={(val) => toCurrency(val)} />
                  </FormInput>
                </Col>
                <Col md={6}>
                  <FormInput name="mfusedamount" comcode="usedAmount">
                    <Value formatter={(val) => toCurrency(val)} />
                  </FormInput>
                </Col>

                <FormInput col md={6} name="lastinvoicedate">
                  <Value />
                </FormInput>

                <FormInput col md={6} name="lastinvoicamount">
                  <Value formatter={(val) => toCurrency(val)} />
                </FormInput>
                <Col md={6}>
                  <FormInput name="outstandingamount">
                    <Value formatter={(val) => toCurrency(val)} />
                  </FormInput>
                </Col>
                <Col
                  span={6}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <Tag color="magenta" style={{ borderRadius: 5 }}>
                    <FormInput
                      name="effectDate"
                      noMargin
                      rules={[{ required: true }]}
                    >
                      {(form.getFieldValue('flagretailer') && mode==='SIMUL')? (
                        <Select
                          size="middle"
                          style={{ width: '100%' }}
                          onChange={handleEffectDateChange}
                        >
                          {optionDates}
                        </Select>
                      ) : (
                        <DatePicker
                          disabled={mode === 'REAL'}
                          size="middle"
                          onChange={(e) => {
                            if (mode === 'SIMUL') {
                              // if (form.getFieldValue('flagretailer')) {
                              //   calculatefeesToInvoice(e);
                              // } else {
                              calculatePreFin(e);
                              // }
                            }
                          }}
                          //disabledDate={disableDaysBeforeToday}
                        />
                      )}
                    </FormInput>
                  </Tag>
                </Col>

                <FormInput col md={6} name="totalreimbursment">
                  <Value formatter={(val) => toCurrency(val)} />
                </FormInput>

                <FormInput col md={6} name="totalinvoicedamount">
                  <Value formatter={(val) => toCurrency(val)} />
                </FormInput>
              </Row>

              <Row gutter={10}>
                <Col span={18}>
                  <Form.Item noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      return (
                        <DataGrid
                          scroll={{ x: 1000, y: 900 }}
                          columns={columns}
                          rowKey={(element, index) => element.cteid}
                          dataSource={getFieldValue('elemList')}
                          rowSelection={rowSelection}
                          pagination={false}
                          isLoading={isLoading === 'POFF'}
                        />
                      );
                    }}
                  </Form.Item>
                </Col>
                <Col
                  span={6}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <Tag color="white" style={{ marginTop: 10, borderRadius: 5 }}>
                    <FormInput
                      name="payOffAmount"
                      noMargin
                      rules={[{ required: true }]}
                    >
                      <InputCurrency
                        currcode={form.getFieldValue('currcode')}
                        max={form.getFieldValue('outstandingamount')}
                        onChange={(e) => {
                          setisLoading('POFF');
                          onChangepayOffAmount(e);
                          //   form.setFieldValue('elemList', rows);
                        }}
                        value={form.getFieldValue('outstandingamount')}
                        disabled={mode === 'REAL'}
                        size="middle"
                      />
                    </FormInput>
                  </Tag>

                  <Tag color="white" style={{ marginTop: 10, borderRadius: 5 }}>
                    <Spin spinning={isLoading === 'POFF'} tip="Calculation...">
                      <FormInput name="newOutstanding" noMargin>
                        <Value formatter={(val) => toCurrency(val)} />
                      </FormInput>
                    </Spin>
                  </Tag>
                  <Tag color="white" style={{ marginTop: 10, borderRadius: 5 }}>
                    <Spin
                      spinning={isLoading === 'INTERSET'}
                      tip="Calculation..."
                    >
                      <FormInput
                        name="intereststoinvoice"
                        noMargin
                        shouldUpdate
                      >
                        <Value formatter={(val) => toCurrency(val)} />
                      </FormInput>
                    </Spin>
                  </Tag>

                  <Tag color="green" style={{ marginTop: 10, borderRadius: 5 }}>
                    <Spin
                      spinning={isLoading === 'INTERSET'}
                      tip="Calculation..."
                    >
                      <FormInput name="totaltoinvoice" noMargin shouldUpdate>
                        <Value formatter={(val) => toCurrency(val)} />
                      </FormInput>
                    </Spin>
                  </Tag>
                </Col>
              </Row>
            </UtinaCard>
            {/* <UtinaCard comcode="listService" level={5}>
              <Form.Item shouldUpdate>
                {({ getFieldValue }) => {
                  const SERV: any[] = Array.isArray(
                    form.getFieldValue(['elements', 'SERV'])
                  )
                    ? form.getFieldValue(['elements', 'SERV'])
                    : [];


                  const elements = [...SERV];
                  const obj = {
                    finschedule: form.getFieldValue(getName('conElemSchedules', 0)),
                    ctegraceperiodduration: form.getFieldValue(
                      getName('ctegraceperiodduration', '0')
                    ),
                    ctefinancedamount: form.getFieldValue(
                      getName('ctefinancedamount', '0')
                    ),
                    cteinvestamount: form.getFieldValue(
                      getName('ctefinancedamount', '0')
                    ),
                    assetamount: form.getFieldValue(
                      getName('ctefinancedamount', '0')
                    ),
                    ctestartdate: form.getFieldValue(getName('ctestartdate', 0)),
                    cteduration: form.getFieldValue(getName('cteduration', 0)),
                  };
                  return (
                    <ElementsTable
                      offerid={getFieldValue('offerid')}
                      form={form}
                      elements={elements}
                      phase="PROD"
                      onConvertServToFinServ={() => {}}
                      propsforcalculate={obj}
                      currcode={getFieldValue('currcode')}
                      onDeleteElement={() => {}}
                    />
                  );
                }}
              </Form.Item>
            </UtinaCard> */}
            <Row>
              <UtinaCard
                level={5}
                comcode="partialPayoff"
                styleCard={{
                  color: '#000',
                  paddingTop: 2,
                  paddingBottom: 10,
                }}
                lg={7}
              >
                <Row>
                  <FormInput
                    col
                    xs={24}
                    name="payOffFormula"
                    wrapperCol={{ span: 24 }}
                  >
                    <PricingListFilteredSelect
                      //disabled={!getFieldValue('offerid')}
                      allowClear
                      params={{
                        offerid: contract?.offerid ?? 0,
                        ctetype: targetStatus === 'PARTIAL' ? 'PPOF' : 'TPOF', // Modifictaion fees
                        prcode: contract?.prcode ?? '',
                        entity: '',
                        entityid: 0,
                        tpid: contract?.tpidclient ?? 0,
                      }}
                      disabled={mode === 'REAL'}
                      onChange={(e) => e && calculateTPOFFees(e)}
                    />
                  </FormInput>
                  <FormInput col xs={24} name="payOffFeesAmount">
                    <InputCurrency
                      currcode={
                        contract?.currcode ??
                        String(localStorage.getItem('currcode'))
                      }
                      onChange={(e) => {
                        //handleinPPayoffFeesAmountChange(e);
                      }}
                      disabled={mode === 'REAL'}
                    />
                  </FormInput>
                </Row>
              </UtinaCard>
              <UtinaCard
                level={5}
                comcode="FeesFormula"
                styleCard={{
                  color: '#000',
                  paddingTop: 2,
                  paddingBottom: 25,
                }}
                lg={5}
              >
                <Row>
                  <FormInput
                    col
                    xs={24}
                    name="feesFormula"
                    //rules={[{ required: true }]}
                  >
                    <PricingListFilteredSelect
                      //disabled={!getFieldValue('offerid')}
                      allowClear
                      params={{
                        offerid: contract?.offerid ?? 0,
                        ctetype: 'MODFEES', // Modifictaion fees
                        prcode: contract?.prcode ?? '',
                        entity: '',
                        entityid: 0,
                        tpid: contract?.tpidclient ?? 0,
                      }}
                      onClear={() => {
                        form?.setFieldValue('feesAmount', 0);
                      }}
                      disabled={mode === 'REAL'}
                      onChange={(e) => calculateFees(e)}
                    />
                  </FormInput>
                </Row>
                <Row>
                  <FormInput name="feesAmount" shouldUpdate>
                    <InputCurrency
                      currcode={
                        contract?.currcode ??
                        localStorage.getItem('currcode') ??
                        ''
                      }
                      defaultValue={0}
                      disabled={
                        form?.getFieldValue('feesFormula') === undefined ||
                        mode === 'REAL'
                      }
                    />
                  </FormInput>
                </Row>
              </UtinaCard>
              {targetStatus === 'PARTIAL' && (
                <UtinaCard
                  level={5}
                  comcode="ChangeDurationandRate"
                  styleCard={{
                    color: '#000',
                    paddingTop: 2,
                    paddingBottom: 25,
                  }}
                  lg={11}
                >
                  <Row>
                    <FormInput
                      col
                      xs={24}
                      name="newDuration"
                      rules={[{ required: true }]}
                    >
                      <SliderWithInput
                        // disabled={
                        //   form?.getFieldValue('extendDuration') === false ||
                        //   state.isModSelected
                        // }
                        min={
                          contract?.conElements?.find(
                            (e) => e.ctetype === 'FIN'
                          )?.pricing?.durationmin ?? 0
                        }
                        max={
                          contract?.conElements?.find(
                            (e) => e.ctetype === 'FIN'
                          )?.pricing?.durationmax ?? 100
                        }
                        precision={0}
                        // onChange={handlenewDurationChange}
                        disabled={mode === 'REAL'}
                      />
                    </FormInput>

                    <FormInput
                      col
                      xs={24}
                      name="newRate"
                      rules={[{ required: true }]}
                    >
                      <InputRate disabled={mode === 'REAL'} />
                    </FormInput>
                  </Row>
                </UtinaCard>
              )}
            </Row>

            <UtinaCard
              level={5}
              comcode="reason&&comment"
              styleCard={{
                color: '#000',
                paddingTop: 20,
                paddingBottom: 25,
              }}
              lg={24}
            >
              <Row gutter={10}>
                <FormInput col md={8} name="modreason">
                  <ParListSelect
                    disabled={mode === 'REAL'}
                    parcode="LPREIMREAS"
                  />
                </FormInput>
                <FormInput col md={14} name="comment">
                  <TextArea rows={3} />
                </FormInput>
              </Row>
            </UtinaCard>
          </Spin>
        </FormItem>
      </Form>
    </DF.Provider>
  );
};
export default TabLoanReimbursment;
